import React from 'react';
import Sticky from 'react-stickynode';

const ControlBar = (props) => {
  return (
    <div className="control-bar">
      <Sticky enabled={props.sticky} top={20}>
        {props.children}
      </Sticky>
    </div>
  );
};

export default ControlBar;
